var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, CardBody, CardFooter, CardHeader, Content, ContentVariants, Flex, FlexItem } from '@patternfly/react-core';
import { HelperText } from '@patternfly/react-core/dist/dynamic/components/HelperText';
import { HelperTextItem } from '@patternfly/react-core/dist/dynamic/components/HelperText';
import { createUseStyles } from 'react-jss';
import { css } from '@patternfly/react-styles';
const useStyles = createUseStyles({
    fullHeightCard: {
        height: '100%'
    },
    image: {
        marginRight: 'var(--pf-t--global--spacer--md)',
        width: 48
    }
});
const ServiceCard = (_a) => {
    var { title, subtitle, description, icon, helperText, footer = null, ouiaId = 'ServiceCard', isStacked = false, isFullHeight = false } = _a, props = __rest(_a, ["title", "subtitle", "description", "icon", "helperText", "footer", "ouiaId", "isStacked", "isFullHeight"]);
    const classes = useStyles();
    return (_jsxs(Card, Object.assign({ className: css({ [classes.fullHeightCard]: isFullHeight }), ouiaId: `${ouiaId}-card` }, props, { children: [_jsx(CardHeader, { children: _jsxs(Flex, { direction: { default: isStacked ? 'column' : 'row' }, alignItems: { default: isStacked ? 'alignItemsFlexStart' : 'alignItemsCenter' }, children: [_jsx(FlexItem, { className: classes.image, children: icon }), _jsx(FlexItem, { children: _jsxs(Content, { children: [_jsx(Content, { component: ContentVariants.h2, ouiaId: `${ouiaId}-title`, children: title }), subtitle !== null && subtitle !== void 0 ? subtitle : null] }) })] }) }), _jsx(CardBody, { "data-ouia-component-id": `${ouiaId}-description`, children: description }), footer || helperText ? (_jsxs(CardFooter, { "data-ouia-component-id": `${ouiaId}-footer`, children: [helperText ?
                        (_jsx(HelperText, { "data-ouia-component-id": `${ouiaId}-helper-text`, children: _jsx(HelperTextItem, { className: "pf-v6-u-mb-lg", children: helperText }) })) : null, footer] })) : null] })));
};
export default ServiceCard;
